import React from 'react';

import './PageNotFound.scss';

function PageNotFound() {
  return <div>404: PageNotFound</div>;
}

export default PageNotFound;
